import { createAction } from 'redux-actions'

export const RESET_ERROR_MESSAGE = createAction('error/RESET_ERROR_MESSAGE')



// WEBPACK FOOTER //
// ./actions/error.js